import {
  createStyles,
  IconButton,
  makeStyles,
  SwipeableDrawer,
  Theme,
  List,
  ListSubheader,
  ListItem,
  Collapse,
  ListItemText,
  Typography,
  Grid,
  Avatar,
  Select,
  FormControl,
  Button,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import {
  Clear,
  ExpandLess,
  ExpandMore,
  Home,
  HouseOutlined,
  MapOutlined,
  Menu,
  RestaurantMenuOutlined,
  Room,
} from "@material-ui/icons";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useCleverlynkContext } from "../../contexts/CleverlynkContext";
import useLandingFunctions from "../../hooks/useLandingFunctions";
import useTemplateStyles from "../../hooks/useTemplateStyles";
import { PFXCategory } from "../../pages/Template";
import {
  selectActiveGroupMembers,
  selectCleverlynk,
  selectCleverlynkGroup,
  selectCompany,
  selectNoLanding,
  selectTriggerNavToUserForm,
} from "../../redux/slices/cleverlynkSlice";
import { selectCatalog, selectCategoryEntities } from "../../redux/slices/templateSlice";
import { scrollToCat } from "../Templates/TemplateTypes/DrawerTemplate";
import { ReactComponent as MenuTop } from "../../images/menudrawer.svg";
import GroupPopup from "./GroupPopup";
import { hexaWithAToRGB } from "../../hooks/useClynkTheme";
import { useTranslation } from "react-i18next";
import useCleverlynkFunctions from "../../hooks/useCleverlynkFunctions";
import GroupDrawerSection from "./GroupDrawerSection";
import { PFXCleverlynkGroupType } from "../../models/Interfaces";

interface IDrawer {
  color: string;
}

const Drawer = (props: IDrawer) => {
  const [open, setOpen] = useState<boolean>(false);
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(new Set());
  const [expandMenu, setExpandMenu] = useState<boolean>(false);

  const cleverlynkContext = useCleverlynkContext();
  const basePath = React.useMemo(() => cleverlynkContext?.basePath ?? "", [cleverlynkContext]);
  const { navbarStyles } = useTemplateStyles();
  const { handleGoToLanding, handleGoToCoverage } = useLandingFunctions();
  const { cardStyles } = useTemplateStyles();
  const { handleGoToCatalog } = useLandingFunctions();
  const noLanding = useSelector(selectNoLanding);

  const catalog = useSelector(selectCatalog);
  const categories = useSelector(selectCategoryEntities);
  const company = useSelector(selectCompany);
  const cleverlynkGroup = useSelector(selectCleverlynkGroup);
  const cleverlynk = useSelector(selectCleverlynk);

  const { t } = useTranslation("header");

  const history = useHistory();
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      drawerPaper: {
        width: "85%",
        maxWidth: 350,
        // color: navbarStyles?.navbarTextColor,
        color: "#1a1a1a",
        position: "relative",
        overflowX: "hidden",
      },
      nestedItem: {
        padding: 0,
        paddingLeft: 45,
      },
      primaryCategoryText: {
        fontSize: "1.15rem",
      },
      primarySubCategoryText: {
        fontSize: "1rem",
      },
      listitem: {
        padding: "0px 15px",
        "&.category": {
          paddingLeft: 30,
        },
      },
      mainOptionText: {
        color: "#1a1a1a",
        fontSize: "1.35rem",
        cursor: "pointer",
        "&.white": {
          color: "white",
        },
      },
      companyName: {
        fontSize: "1.2rem",
      },
      topSvg: {
        top: 0,
        left: 0,
        position: "absolute",
        zIndex: -1,
        width: "100%",
      },
      stickToBottom: {
        // position: "fixed",
        // bottom: 0,
        // left: 0,
        flexGrow: 3,
      },
      upperGroupDiv: {
        minHeight: 100,
        backgroundColor: "white",
        color: "#1a1a1a",
        borderTop: "solid 2pt #e7e7e7",
      },
      fillAvailableHeight: {
        height: "-moz-available" /* WebKit-based browsers will ignore this. */,
        //@ts-ignore
        height: "-webkit-fill-available" /* Mozilla-based browsers will ignore this. */,
        //@ts-ignore
        height: "fill-available",
        flexWrap: "nowrap",
      },
      lowerDiv: {
        height: "-moz-available" /* WebKit-based browsers will ignore this. */,
        //@ts-ignore
        height: "-webkit-fill-available" /* Mozilla-based browsers will ignore this. */,
        //@ts-ignore
        height: "fill-available",
        color: "white",
        backgroundColor: "#333333",
        minHeight: 140,
        paddingTop: 20,
        "&.MuiOutlinedInput-notchedOutline": {
          borderColor: "white",
        },
      },
      selectForm: {
        width: "80%",
        margin: 8,
      },
      select: {
        color: "white",
        borderColor: "white",
      },
      selectIcon: {
        color: "#ffffff8a",
      },
      selectRoot: {
        borderColor: "white",
      },
      selectOutlined: {
        color: "white",
      },
      listItem: {
        margin: 8,
        boxShadow: "1pt 1pt 2px 1px #ccc8c87d",
        borderRadius: 5,
        "&.selected": {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.contrastText,
        },
      },
    })
  );
  const classes = useStyles();

  const onClose = () => {
    setOpen(false);
  };

  const handleClick = (
    category: PFXCategory,
    index: number,
    subCategory: PFXCategory | undefined,
    expandableClick: boolean
  ) => {
    scrollToCat(category.id, navbarStyles?.headerColor);
    if (!subCategory && category.categories && category.categories.length > 0 && expandableClick) {
      setExpandedCategories(p => {
        const s = new Set(Array.from(p));
        if (p.has(category.id)) s.delete(category.id);
        else s.add(category.id);
        return s;
      });
    } else if (!subCategory && category.categories && category.categories.length > 0) {
      const queryParams = new URLSearchParams();
      queryParams.append("c", category.id);

      history.push({
        pathname: `${basePath}/menu`.replace("//", "/"),
        search: queryParams.toString(),
      });
      onClose();
    } else if (!subCategory) {
      // template?.setBreadCrumb(category.id);
      // template?.setSubCategoryIndex(0);
      const queryParams = new URLSearchParams();
      queryParams.append("c", category.id);
      history.push({
        pathname: `${basePath}/menu`.replace("//", "/"),
        search: queryParams.toString(),
      });
      onClose();
    } else {
      // template?.setBreadCrumb(subCategory!.id);
      // template?.setSubCategoryIndex(index + 1);
      const queryParams = new URLSearchParams();
      queryParams.append("c", category.id);
      queryParams.append("sc", subCategory!.id);
      history.push({
        pathname: `${basePath}/menu`.replace("//", "/"),
        search: queryParams.toString(),
      });
      onClose();
    }
  };

  const renderGoLanding = useMemo(() => {
    return (
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        style={{
          marginBottom: 15,
          backgroundColor: "#1a1a1a",
          borderRadius: "20px",
          width: "80%",
          marginLeft: 15,
          boxShadow: "1px 1px 3px #cbcbcb82",
          cursor: "pointer",
        }}
        onClick={() => {
          noLanding ? handleGoToCatalog() : handleGoToLanding();
          setOpen(false);
        }}>
        <Grid item style={{ padding: "8px 15px", columnGap: 10 }} container wrap="nowrap" alignItems="center">
          <HouseOutlined style={{ color: "white" }} />
          <Typography className={`white ${classes.mainOptionText}`}>Inicio</Typography>
        </Grid>
      </Grid>
    );
  }, [classes.mainOptionText]);

  const renderGoCoverage = useMemo(() => {
    return cleverlynkGroup?.type === PFXCleverlynkGroupType.GEO || !!cleverlynk?.isUsingGeolocation ? (
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        style={{
          backgroundColor: "white",
          borderRadius: "20px",
          width: "80%",
          marginBottom: 15,
          marginLeft: 15,
          boxShadow: "1px 1px 3px #cbcbcb82",
          cursor: "pointer",
        }}
        onClick={() => {
          handleGoToCoverage();
          setOpen(false);
        }}>
        <Grid item style={{ padding: "8px 15px", columnGap: 10 }} container wrap="nowrap" alignItems="center">
          <MapOutlined style={{ color: "#1a1a1a" }} />
          <Typography className={classes.mainOptionText}>Cobertura</Typography>
        </Grid>
      </Grid>
    ) : null;
  }, [classes.mainOptionText]);

  const renderHeader = useMemo(() => {
    return (
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{
          transition: "margin-bottom 400ms",
          marginBottom: expandedCategories.size > 0 && expandMenu ? 5 : 25,
        }}>
        <Grid item container justifyContent="flex-start" alignItems="flex-start" xs={12}>
          <IconButton onClick={() => setOpen(p => !p)} style={{ padding: 6 }}>
            <Clear
              style={{
                transitionProperty: "width, height",
                transitionDuration: "400ms",
                height: expandedCategories.size > 0 && expandMenu ? "1rem" : "1.2rem",
                width: expandedCategories.size > 0 && expandMenu ? "1rem" : "1.2rem",
              }}
            />
          </IconButton>
        </Grid>
        <Grid
          item
          container
          style={{ paddingRight: 24, paddingTop: expandedCategories.size > 0 && expandMenu ? 0 : 10 }}
          justifyContent="space-evenly"
          alignItems="center">
          <Avatar
            src={company?.logoUrl}
            style={{
              transitionProperty: "width, height",
              transitionDuration: "400ms",
              width: expandedCategories.size > 0 && expandMenu ? 40 : 100,
              height: expandedCategories.size > 0 && expandMenu ? 40 : 100,
              boxShadow: "#7a7a7a 1px 1px 5px -2px",
            }}></Avatar>
        </Grid>
      </Grid>
    );
  }, [classes.mainOptionText, company?.logoUrl, company?.name]);

  const renderMenuContent = () => (
    <Grid item style={{ flexGrow: 2 }}>
      <List
        component="nav"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader" style={{ padding: 0 }}>
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              onClick={() => setExpandMenu(p => !p)}
              wrap="nowrap"
              style={{
                backgroundColor: "white",
                borderRadius: "20px",
                width: "80%",
                marginLeft: 15,
                boxShadow: "1px 1px 3px #cbcbcb82",
                cursor: "pointer",
              }}>
              <Grid item style={{ padding: "8px 15px", columnGap: 10 }} container wrap="nowrap" alignItems="center">
                <RestaurantMenuOutlined style={{ color: "#1a1a1a" }} />
                <Typography className={classes.mainOptionText}>Menú</Typography>
              </Grid>
              <Grid item>
                <IconButton style={{ padding: 8 }}>
                  {expandMenu ? (
                    <ExpandLess style={{ color: navbarStyles?.navbarTextColor, height: "2rem", width: "2rem" }} />
                  ) : (
                    <ExpandMore style={{ color: navbarStyles?.navbarTextColor, height: "2rem", width: "2rem" }} />
                  )}
                </IconButton>
              </Grid>
            </Grid>
          </ListSubheader>
        }>
        <Collapse in={expandMenu} unmountOnExit>
          {catalog?.categories
            .map(c => categories[c.id])
            .filter(
              c =>
                (!!c && c?.items && (c?.items ?? []).length > 0) ||
                (!!c && c?.categories && (c?.categories ?? []).length > 0)
            )
            .map((c, i) => (
              <React.Fragment key={c!.name + i}>
                <ListItem
                  className={`category ${classes.listitem}`}
                  button
                  onClick={() => handleClick(c as PFXCategory, i, undefined, false)}>
                  <ListItemText primary={c!.name} classes={{ primary: classes.primaryCategoryText }} />
                  {c!.categories && c!.categories.length > 0 ? (
                    <IconButton
                      onClick={e => {
                        e.stopPropagation();
                        handleClick(c as PFXCategory, i, undefined, true);
                      }}>
                      {expandedCategories.has(c!.id) ? (
                        <ExpandLess style={{ color: navbarStyles?.navbarTextColor }} />
                      ) : (
                        <ExpandMore style={{ color: navbarStyles?.navbarTextColor }} />
                      )}
                    </IconButton>
                  ) : null}
                </ListItem>
                {c!.categories && c!.categories.length > 0 && (
                  <Collapse in={expandedCategories.has(c!.id)} unmountOnExit>
                    <List component="div" disablePadding>
                      {c!.categories
                        .filter(
                          c =>
                            (!!c && c?.items && (c?.items ?? []).length > 0) ||
                            (!!c && c?.categories && (c?.categories ?? []).length > 0)
                        )
                        .map((sc, sci) => (
                          <ListItem
                            className={classes.nestedItem}
                            button
                            onClick={() => handleClick(c as PFXCategory, sci, sc, false)}>
                            <ListItemText
                              primary={categories[sc?.id]?.name}
                              classes={{ primary: classes.primarySubCategoryText }}
                            />
                          </ListItem>
                        ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
        </Collapse>
      </List>
    </Grid>
  );

  return (
    <React.Fragment>
      <IconButton style={{ padding: 8 }} onClick={() => setOpen(p => !p)}>
        <Menu style={{ color: props.color }} />
      </IconButton>
      <SwipeableDrawer
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        classes={{ paper: classes.drawerPaper }}>
        <MenuTop fill={`#f3f3f3`} className={classes.topSvg} />
        {renderHeader}
        {renderGoLanding}
        {renderGoCoverage}
        <Grid
          id="estavaina"
          container
          justifyContent="space-between"
          direction="column"
          className={classes.fillAvailableHeight}>
          {renderMenuContent()}
          <GroupDrawerSection onClose={onClose} collapse={(expandedCategories.size > 0 && expandMenu) || !expandMenu} />
        </Grid>
      </SwipeableDrawer>
    </React.Fragment>
  );
};

export default Drawer;
